import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure42 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '2000px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
groupedOptions: [{
	  style: {
			 transform: 'unset'
		 },
  }],
  style: {
			 transform: 'translateX(11px)'
		 },
		 align: 'right'
},
categories: [
{
name: "Caraïbes",
categories: ["Sainte-Lucie*", "Saint-Vincent-et-les Grenadines*", "République dominicaine*"]
},
{
name: "Amérique latine",
categories: ["Belize", "Guyana", "Chili", "Suriname", "Équateur", "Mexique", "Costa Rica", "Uruguay*", "Pérou", "Paraguay", "Nicaragua", "Guatemala", "Bolivie (État plurinational de)", "Colombie", "Amérique centrale**", "Amérique du Sud**"]
},
{
name: "Asie centrale et Asie du Sud",
categories: ["Pakistan", "Ouzbékistan*", "Népal*"]
},
{
name: "Asie de l’Est et Asie du Sud-Est",
categories: ["Myanmar", "Thaïlande*", "Mongolie", "Viet Nam", "Cambodge^",]
},
{
name: "Asie de l’Ouest",
categories: ["Liban*","Palestine*","Yémen*","Qatar*","Jordanie*","Türkiye*","Azerbaïdjan*","Arménie* ^","Géorgie* ^","Asie de l’Ouest"]
},
{
name: "Afrique subsaharienne",
categories: ["Djibouti", "Mauritanie*", "Sierra Leone", "Ghana", "Sénégal*", "Niger", "Madagascar", "Zimbabwe", "Mali ", "Malawi", "République centrafricaine", "Côte d’Ivoire", "Tchad ", "Togo", "Libéria", "Namibie", "Ouganda", "République-Unie de Tanzanie", "Kenya", "Bénin", "Éthiopie^", "Rwanda^", "Burkina Faso"]
},
{
name: "",
categories: ["Afrique de l’Ouest**"]
},
{
name: "Europe",
categories: ["Bosnie-Herzégovine*", "Bélarus*", "République de Moldova*", "Suisse*", "Allemagne*", "Slovaquie*", "Macédoine du Nord*", "Monténégro*", "Italie", "Suède* ^", "Serbie*", "Portugal", "Hongrie* ^", "Lituanie* ^"]
},
{
name: "",
categories: ["Pays en développement sans littoral"]
},
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 25,
}],
yAxis: [{
labels: {
  style: {
		 fontWeight: 'normal',
		 color: '#999999',
		 fontSize: '11px'
	 },
	},
	min: 0,
	max: 6,
	tickInterval: 1,	
format: '{value}%',
gridLineWidth: 1,
floor: 0,

title: {
  text: '',
  style: {
		color: Highcharts.getOptions().colors[1]
	}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
valueSuffix: '%',
style: {
  padding: 0
}
},
legend: {
enabled: false,
},

series: [{
name: '',
color: '#5b9bd5',
data: [
1,
2,
3,
1,
2,
2,
2,
3,
3,
3,
4,
5,
5,
5,
5,
5,
6,
3,
4,
2,
3,
4,
1,
4,
4,
4,
6,
1,
1,
1,
1,
1,
3,
3,
3,
5,
2,
1,
1,
1,
1,
2,
2,
2,
3,
3,
3,
3,
3,
4,
4,
4,
5,
5,
5,
5,
5,
6,
6,
6,
3,
3,
3,
3,
3,
4,
4,
4,
4,
4,
5,
5,
5,
5,
5,
4,
]
}]
}
